import LoopingEllipsis from '@/components/LoopingEllipsis';
import Card from '@mui/material/Card';
import Text from '@/components/Text';
import { classes, styles } from './utils';

export default function CheckingAuth() {
  return (
    <div className={classes.wrapper}>
      <Card raised sx={styles.card} className={classes.card}>
        <div className={classes.text}>
          <Text>Checking permissions</Text>
          <LoopingEllipsis />
        </div>
      </Card>
    </div>
  );
}
